require('./src/styles/purgedStyles.scss');
require('./src/styles/unpurgedStyles.scss');

// turning off the default behaviour which will now be handled by 'gatsby-plugin-transitions'
exports.shouldUpdateScroll = () => {
  return false;
};
